import { Component, OnInit, Input } from '@angular/core';
import { DATA_PER_PAGE } from '@root/app.constant';

@Component({
  selector: 'app-catalog-nav-divident-list',
  templateUrl: './catalog-nav-divident-list.component.html',
  styleUrls: ['./catalog-nav-divident-list.component.scss']
})
export class CatalogNavDividentListComponent implements OnInit {
  @Input() data: any[];

  pageSize: number = DATA_PER_PAGE;

  constructor() { }

  ngOnInit() {
  }

}
